import { initAnalytics } from "artisan-commerce/analytics";
import { Providers } from "artisan-commerce/analytics";

import packageJSON from "../../../package.json";

export const hasAnalytics =
  !!process.env.REACT_APP_SEGMENT_WRITE_KEY &&
  !!process.env.REACT_APP_SEGMENT_TRACKID &&
  process.env.REACT_APP_GOOGLE_TRACKID;

export const segmentAnalyticsProvider = new Providers.Segment({
  name: "Segment XONE",
  vendors: undefined,
  writeKey: process.env.REACT_APP_SEGMENT_WRITE_KEY as string,
  trackingId: process.env.REACT_APP_SEGMENT_TRACKID as string
});

export const googleAnalyticsProvider = new Providers.GoogleAnalytics({
  name: "GA XONE",
  trackingId: process.env.REACT_APP_GOOGLE_TRACKID as string,
  vendors: undefined
});

/**
 * Initialize the analytics library
 * @param activeVendor Current active vendor
 */
export const initAnalyticsLib = (accountId: number) => {
  initAnalytics({
    activeVendor: -1,
    providers: [googleAnalyticsProvider, segmentAnalyticsProvider],
    vendors: undefined,
    meta: {
      accountId: accountId,
      appName: packageJSON.name,
      versionApp: packageJSON.version
    },
    debug: process.env.NODE_ENV === "development"
  });
};
